<!-- Modal backdrop con animación de fade -->
@if (isOpen()) {
  <div
    class="fixed inset-0 bg-black/60 z-[100] flex items-center justify-center transition-opacity duration-300 ease-in-out overflow-y-auto py-10"
    (click)="closeModal()"
    >
    <!-- Contenedor del modal con animación de entrada y salida -->
    <div
      class="bg-white rounded-lg shadow-md w-11/12 sm:w-10/12 md:w-8/12 lg:w-6/12 max-w-lg mx-auto z-50 overflow-hidden transform transition-all duration-300 ease-in-out"
      (click)="$event.stopPropagation()"
      >
      <!-- Cabecera del modal -->
      <div
        class="px-4 sm:px-6 py-3 sm:py-4 border-b border-amber-300 flex justify-between items-center bg-amber-400"
        >
        <h3 class="text-base sm:text-lg font-medium text-black">Tarifa dinámica</h3>
        <button
          (click)="closeModal()"
          class="text-black hover:text-gray-800 focus:outline-none transition-transform duration-300 hover:scale-110"
          >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="1.5"
            >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
              />
          </svg>
        </button>
      </div>
      <!-- Contenido del modal -->
      <div class="p-4 sm:p-6">
        <div class="text-center">
          <!-- Imagen del multiplicador -->
          <div class="mb-6 flex justify-center">
            <img
              [src]="image()"
              alt="Multiplicador"
              class="max-w-full h-auto max-h-80 object-contain rounded-lg shadow-sm"
            />
          </div>
          <!-- Información adicional -->
          <div class="mb-6">
            <h4 class="text-lg font-medium text-gray-900 mb-2">La tarifa puede variar según tu ubicación, el clima o la disponibilidad de repartidores.</h4>
            <p class="text-gray-600">Siempre verás el costo total antes de confirmar tu pedido</p>
          </div>
          <!-- Botón de cerrar -->
          <div class="flex justify-center mt-6">
            <button
              (click)="closeModal()"
              class="px-6 py-2 bg-amber-400 text-white rounded-md hover:bg-amber-500 transition-colors duration-300 font-medium"
              >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
